import { showError, clearErrors } from "./errors";
import formSubmit from "./formSubmit";

export default function validate(form) {
  clearErrors();

  const errors = [];

  // Имя
  const nameInput = form.querySelector('[name="name"]');
  if (!nameInput.value.trim() || nameInput.value.trim().length < 2) {
    errors.push({
      field: nameInput,
      message: "Введите имя (минимум 2 символа)",
    });
  }

  // Телефон
  const phoneInput = form.querySelector('[name="phone"]');
  const phoneDigits = phoneInput.value.replace(/\D/g, "");
  if (phoneDigits.length < 10) {
    errors.push({
      field: phoneInput,
      message: "Введите корректный номер телефона",
    });
  }


  // Если есть ошибки
  if (errors.length) {
    errors.forEach(showError);
    return;
  }

  // ✅ Всё ок — собираем FormData
  const formData = new FormData(form);

  const data = {
    act: "form_submit",
    userName: formData.get('name'),
    userPhone: formData.get('phone'),
    tip: formData.get('type-phone')
  }

  const btnSubmitEl = form.querySelector('.modal__btn');
  // console.log(btnSubmitEl);
  if (btnSubmitEl && btnSubmitEl.hasAttribute('car_id')) {
    // data.car_id = btnSubmitEl.getAttribute('car_id');
    data.id = btnSubmitEl.getAttribute('car_id');
  }

  if (btnSubmitEl && btnSubmitEl.hasAttribute('going')) {
    data.going = btnSubmitEl.getAttribute('going');
  }

  // console.log(data);
  
  formSubmit(data);
}


